import { getOrCreateFrameId } from '../../utils';
export class TargetAppPredicate {
  isTargetAudience({
    apps
  }, {
    client: {
      appName
    }
  }) {
    return apps.size === 0 || apps.has(appName);
  }
}
export class MatchingTagPredicate {
  isTargetAudience({
    tags
  }, {
    client: {
      tags: clientTags
    }
  }) {
    return tags.size === 0 || Array.from(tags).some(tag => clientTags.includes(tag));
  }
}
export class ExcludeSelfPredicate {
  isTargetAudience({
    excludeSelf
  }, {
    subscriberClientId,
    message: {
      sender
    }
  }) {
    return !excludeSelf || subscriberClientId !== sender;
  }
}
export class SameWindowPredicate {
  isTargetAudience({
    sameWindow
  }, {
    message: {
      senderFrameId
    }
  }) {
    const currentFrameId = getOrCreateFrameId();
    return !sameWindow || senderFrameId === currentFrameId;
  }
}
export class CrossTabPredicate {
  isTargetAudience({
    allowCrossTab
  }, {
    message: {
      senderBrokerId
    },
    subscriberBrokerId
  }) {
    return allowCrossTab || senderBrokerId === subscriberBrokerId;
  }
}
export class CrossPortalPredicate {
  isTargetAudience({
    allowCrossPortal
  }, {
    message: {
      senderPortalId
    },
    client: {
      portalId
    }
  }) {
    const areClientAndSenderHubless = !senderPortalId && !portalId;
    return allowCrossPortal || areClientAndSenderHubless || senderPortalId === portalId;
  }
}

/**
 * Predicate that checks if a client matches the label requirements of an audience filter.
 * For each label in the audience filter we MUST have a matching value for that label in the client's context.
 */
export class MatchingLabelPredicate {
  isTargetAudience({
    labels
  }, {
    client
  }) {
    return Array.from(labels.entries()).every(([key, allowedValues]) => {
      var _client$labels;
      const clientValues = new Set(((_client$labels = client.labels) === null || _client$labels === void 0 ? void 0 : _client$labels[key]) || []);
      return Array.from(allowedValues).some(value => clientValues.has(value));
    });
  }
}